module.exports = __webpack_public_path__ + "static/blinkrx-card-33be3696b3bd8e53005a3dc518b4bacc.png";